import {Page} from '../lib/material-ui-components'
import {AuthSystem} from '../lib/auth-system'
import {path, appBase} from '../lib/routes'

declare let React: any
declare let ReactRouterDOM: any

const {withRouter} = ReactRouterDOM

const Login = withRouter(({location, history}) => {
  const authSystem = AuthSystem.getInstance()
  
  // Verifica se l'URL di login è valido (solo per informazioni, non per bloccare l'accesso)
  const isUrlValid = authSystem.isLoginUrlValid(location.pathname)
  
  const handleEnter = () => {
    // Genera un nuovo token di accesso
    const token = authSystem.generateAuthToken()
    console.log('🔑 Token di accesso generato:', token)
    
    // Verifica che il token sia stato salvato correttamente
    const tokenValid = authSystem.isTokenValid()
    console.log('✅ Token valido dopo generazione:', tokenValid)
    
    // Controlla se c'è un URL di reindirizzamento
    const urlParams = new URLSearchParams(location.search)
    const redirectUrl = urlParams.get('redirect')
    
    if (redirectUrl) {
      // Reindirizza all'URL specificato
      console.log('🎯 Reindirizzamento a:', redirectUrl)
      // Usa un piccolo delay per assicurarsi che il token sia salvato
      setTimeout(() => {
        window.location.href = redirectUrl
      }, 100)
    } else {
      // Reindirizza alla home page usando il routing corretto
      const base = appBase()
      const homeUrl = `${window.location.origin}${base}/`
      console.log('🏠 Reindirizzamento a:', homeUrl)
      // Usa un piccolo delay per assicurarsi che il token sia salvato
      setTimeout(() => {
        window.location.href = homeUrl
      }, 100)
    }
  }

  const handleRenewToken = () => {
    // Rinnova il token esistente
    const token = authSystem.generateAuthToken()
    console.log('🔄 Token rinnovato:', token)
    
    // Reindirizza alla home page usando il routing corretto
    const base = appBase()
    const homeUrl = `${window.location.origin}${base}/`
    console.log('🏠 Reindirizzamento a:', homeUrl)
    window.location.href = homeUrl
  }

  const formatExpiryTime = (timestamp: number): string => {
    const date = new Date(timestamp)
    return date.toLocaleString('it-IT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })
  }

  const authStatus = authSystem.getAuthStatus()

  return (
    <Page title='Accesso Museo Genio' top={true}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        textAlign: 'center',
        padding: '20px'
      }}>
        <div style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          borderRadius: '20px',
          padding: '40px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
          maxWidth: '400px',
          width: '100%'
        }}>
          <h1 style={{
            color: 'white',
            marginBottom: '30px',
            fontSize: '2.5em',
            fontWeight: 'bold'
          }}>
            Museo Genio
          </h1>
          
          {/* Avviso se l'URL non è valido */}
          {!isUrlValid && (
            <div style={{
              backgroundColor: 'rgba(255, 193, 7, 0.2)',
              border: '2px solid #FFC107',
              borderRadius: '10px',
              padding: '15px',
              marginBottom: '20px',
              color: '#FFC107'
            }}>
              <p style={{ margin: '5px 0', fontWeight: 'bold' }}>
                ⚠️ URL di Login Non Valido
              </p>
              <p style={{ margin: '5px 0', fontSize: '0.9em' }}>
                Questo link potrebbe essere scaduto o non valido. 
                Tuttavia puoi comunque accedere se hai le credenziali corrette.
              </p>
              <button
                onClick={() => {
                  const newUrl = authSystem.generateNewLoginUrl()
                  const fullUrl = `${window.location.origin}${newUrl}`
                  console.log('🔄 Nuovo URL generato:', fullUrl)
                  // Copia l'URL negli appunti
                  navigator.clipboard.writeText(fullUrl).then(() => {
                    alert('Nuovo URL di login generato e copiato negli appunti!')
                  }).catch(() => {
                    alert(`Nuovo URL di login: ${fullUrl}`)
                  })
                }}
                style={{
                  background: 'linear-gradient(45deg, #FF9800, #F57C00)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '25px',
                  padding: '8px 20px',
                  fontSize: '0.9em',
                  cursor: 'pointer',
                  marginTop: '10px',
                  transition: 'all 0.3s ease'
                }}
              >
                🔄 Genera Nuovo URL
              </button>
            </div>
          )}
          
          <p style={{
            color: 'rgba(255,255,255,0.9)',
            marginBottom: '40px',
            fontSize: '1.1em',
            lineHeight: '1.6'
          }}>
            {authSystem.isTokenValid() 
              ? 'Sei già autenticato! Puoi rinnovare il tuo accesso o tornare alla home.'
              : 'Benvenuto nell\'esperienza immersiva del Museo Genio'
            }
          </p>

          {authSystem.isTokenValid() ? (
            // Se l'utente è già autenticato, mostra pulsanti per rinnovare o tornare alla home
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', alignItems: 'center' }}>
              <button
                onClick={handleRenewToken}
                style={{
                  background: 'linear-gradient(45deg, #FF9800, #F57C00)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '50px',
                  padding: '15px 40px',
                  fontSize: '1.2em',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 4px 15px rgba(255, 152, 0, 0.3)',
                  minWidth: '200px'
                }}
                onMouseOver={(e) => {
                  e.target.style.transform = 'translateY(-2px)'
                  e.target.style.boxShadow = '0 6px 20px rgba(255, 152, 0, 0.4)'
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = 'translateY(0)'
                  e.target.style.boxShadow = '0 4px 15px rgba(255, 152, 0, 0.3)'
                }}
              >
                🔄 Rinnova Accesso
              </button>
              
              <button
                onClick={() => {
                  // Verifica se l'utente è autenticato prima di reindirizzare
                  if (authSystem.isTokenValid()) {
                    const base = appBase()
                    const homeUrl = `${window.location.origin}${base}/`
                    console.log('🏠 Ritorno diretto alla home (utente autenticato):', homeUrl)
                    window.location.href = homeUrl
                  } else {
                    // Se non è autenticato, mostra un messaggio invece di reindirizzare
                    alert('Devi prima effettuare il login per accedere alla home page.')
                  }
                }}
                style={{
                  background: 'linear-gradient(45deg, #2196F3, #1976D2)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '50px',
                  padding: '12px 30px',
                  fontSize: '1em',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 4px 15px rgba(33, 150, 243, 0.3)',
                  minWidth: '180px'
                }}
                onMouseOver={(e) => {
                  e.target.style.transform = 'translateY(-2px)'
                  e.target.style.boxShadow = '0 6px 20px rgba(33, 150, 243, 0.4)'
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = 'translateY(0)'
                  e.target.style.boxShadow = '0 4px 15px rgba(33, 150, 243, 0.3)'
                }}
              >
                🏠 Torna alla Home
              </button>
            </div>
          ) : (
            // Se l'utente non è autenticato, mostra pulsante per entrare
            <button
              onClick={handleEnter}
              style={{
                background: 'linear-gradient(45deg, #4CAF50, #45a049)',
                color: 'white',
                border: 'none',
                borderRadius: '50px',
                padding: '15px 40px',
                fontSize: '1.2em',
                fontWeight: 'bold',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 15px rgba(76, 175, 80, 0.3)',
                minWidth: '200px'
              }}
              onMouseOver={(e) => {
                e.target.style.transform = 'translateY(-2px)'
                e.target.style.boxShadow = '0 6px 20px rgba(76, 175, 80, 0.4)'
              }}
              onMouseOut={(e) => {
                e.target.style.transform = 'translateY(0)'
                e.target.style.boxShadow = '0 4px 15px rgba(76, 175, 80, 0.3)'
              }}
            >
              🚀 Entrare
            </button>
          )}

          <div style={{
            marginTop: '30px',
            padding: '20px',
            backgroundColor: 'rgba(255,255,255,0.1)',
            borderRadius: '10px',
            fontSize: '0.9em',
            color: 'rgba(255,255,255,0.8)'
          }}>
            <p style={{ margin: '5px 0' }}>
              <strong>URL valido fino:</strong><br />
              {authStatus.urlExpiresAt ? formatExpiryTime(authStatus.urlExpiresAt) : 'Non disponibile'}
            </p>
            <p style={{ margin: '5px 0' }}>
              <strong>Token valido per:</strong> 2 ore
            </p>
          </div>
        </div>
      </div>
    </Page>
  )
})

export {Login} 